export default function ContactInfo() {
    return (
        <div className="space-y-8">
            <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                    Contact Methods
                </h3>
                <div className="space-y-4">
                    <div className="flex items-center">
                        <svg className="w-6 h-6 text-primary mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                        <a href="mailto:info@continuationtrade.com" className="text-gray-600 dark:text-gray-300 hover:text-primary dark:hover:text-blue-400">
                            info@continuationtrade.com
                        </a>
                    </div>
                    <div className="flex items-center">
                        <svg className="w-6 h-6 text-primary mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                        <a href="tel:+12243349387" className="text-gray-600 dark:text-gray-300 hover:text-primary dark:hover:text-blue-400">
                            +1 224 334 9387
                        </a>
                    </div>
                </div>
            </div>

            <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                    Business Hours
                </h3>
                <div className="space-y-2 text-gray-600 dark:text-gray-300">
                    <p>Monday - Friday: 9:00 AM - 6:00 PM (CST)</p>
                    <p>Saturday - Sunday: Closed</p>
                </div>
            </div>
        </div>
    );
} 